// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContentId_QUICKWIN } from "../schema";

export function serialize_ContentId_QUICKWIN_internal(value: ContentId_QUICKWIN): unknown {
  return ((value: { contentType: "QUICKWIN"; id: bigint }): unknown => {
    return {
      contentType: ((value: "QUICKWIN"): unknown => {
        return value;
      })(value["contentType"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
    };
  })(value);
}
export function serialize_ContentId_QUICKWIN(obj: ContentId_QUICKWIN): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentId_QUICKWIN_internal(obj));
}
export function deserialize_ContentId_QUICKWIN_internal(value: unknown): ParserResult<ContentId_QUICKWIN> {
  return ((
    value: unknown,
  ): ParserResult<{
    contentType: "QUICKWIN";
    id: bigint;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/QuickWinId]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/QuickWinId]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "contentType")) {
      return { success: false, reason: `[#/components/schemas/QuickWinId/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
    }
    const parsed_contentType = ((): ParserResult<"QUICKWIN"> => {
      return ((value: unknown): ParserResult<"QUICKWIN"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/QuickWinId/contentType]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "QUICKWIN":
            return { success: true, value: "QUICKWIN" };
          default:
            return { success: false, reason: `[#/components/schemas/QuickWinId/contentType]: '${value}' expected to be enum, one of 'QUICKWIN'.` };
        }
      })(value["contentType"]);
    })();
    if (!parsed_contentType.success) {
      return { success: false, reason: parsed_contentType.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/QuickWinId/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/QuickWinId/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    return { success: true, value: { contentType: parsed_contentType.value, id: parsed_id.value } };
  })(value);
}
export function deserialize_ContentId_QUICKWIN(str: string): ParserResult<ContentId_QUICKWIN> {
  return deserialize_ContentId_QUICKWIN_internal(parseJsonWithNumbersAsBigint(str));
}
